module.exports = __webpack_public_path__ + "img/illustration-grow-together.bb27da81.svg";